import { css } from 'styled-components';
import { tokens } from '@equinor/eds-tokens';
import { shorthand } from './common.mjs';

var focusColor = tokens.colors.interactive.focus.rgba;
var outlineTemplate = function outlineTemplate(outline) {
  var _outline$color = outline.color,
    color = _outline$color === void 0 ? focusColor : _outline$color,
    _outline$style = outline.style,
    style = _outline$style === void 0 ? 'dashed' : _outline$style,
    _outline$width = outline.width,
    width = _outline$width === void 0 ? '2px' : _outline$width,
    _outline$offset = outline.offset,
    offset = _outline$offset === void 0 ? '0px' : _outline$offset,
    type = outline.type;
  var outline_ = {
    color: color,
    style: style,
    width: width,
    offset: offset,
    type: type
  };
  return css({
    outline: shorthand(outline_),
    outlineOffset: outline_.offset
  });
};

export { outlineTemplate };
